class Store {
  constructor() {
    this.vars = window.statelyVars || {};
    this.init();
  }

  init() {
    this.setOrderTag();
  }

  setOrderTag() {
    // _order_tag is a comma-separated LIST: the legacy sessionStorage slot
    // (session-scoped, composed but never persisted), every persistent slot
    // tag this browser still carries (the quiz cohort — see order-tags.js),
    // and every Convert exposure from the persistent order-tag store (Exp-
    // when triggered this session, ExpR- when carried over from a previous
    // one). The Flow's "Add order tags" splits the property on commas into
    // individual order tags.
    // window.smOrderTags is registered by assets/order-tags.js, its own Vite
    // entry loaded before this bundle (a global, not an import, because
    // classic-script bundles can't share module chunks — see its LOADING
    // MODEL note). Fallback when missing: the legacy single-tag behavior.
    const legacyTag = sessionStorage.getItem("order_tag");
    const orderTag =
      window.smOrderTags && typeof window.smOrderTags.composeOrderTags === "function"
        ? window.smOrderTags.composeOrderTags([legacyTag])
        : legacyTag;
    const form = document.querySelector(".product-form form");
    if (orderTag && form) {
      // Idempotent: reuse an existing injected input so a re-run can't leave
      // the form with duplicate properties[_order_tag] fields.
      let input = form.querySelector('input[name="properties[_order_tag]"]');
      if (!input) {
        // DOM API, not an HTML string: the tag contains a Convert variation
        // name, and a quote or angle bracket in it would break out of the
        // value="…" attribute if interpolated into markup.
        input = document.createElement("input");
        input.type = "hidden";
        input.name = "properties[_order_tag]";
        form.appendChild(input);
      }
      input.value = orderTag;
    }
  }
}

window.addEventListener("DOMContentLoaded", () => {
  window.store = new Store();
});
